import React, {useEffect} from 'react';
import { makeStyles,  withStyles } from '@material-ui/core/styles';
import { Checkbox, Box, Collapse, IconButton, TableCell, TableRow, Modal, Grid } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { PaxList } from './paxList'
import { PaxMenu } from "./paxMenu";
import { useDispatch, useSelector } from "react-redux";
// import { closeFlight } from '../../store/departures'
import { NoShowModal } from './noShowModal'
import { loadPaxInfo } from "../../store/departures";

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(4n+1)': {
      backgroundColor: '#dedede',
    },
    '&:nth-of-type(4n+2)': {
      backgroundColor: '#dedede',
    },
    '&:nth-of-type(4n+3)': {
      backgroundColor: 'white' 
    },
    '&:nth-of-type(4n+4)': {
      backgroundColor: 'white' 
    },
  }  
}))(TableRow);

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    }
  }
});


export default function Row(props) {
  const { row, index } = props;
  const dispatch = useDispatch();
  const paxInfo = useSelector(state => state.entities.departures.paxInfo)
  const [openAccordion, setOpenAccordion] = React.useState(false);
  const [openNoShow, setOpenNoShow] = React.useState(false);
  let rowPax = paxInfo.findIndex(p => p.key == props.row.key)
  const classes = useRowStyles();
  // NOTE // They may want to enable close-flight again someday, so DON'T DELETE this block
  // const token = useSelector(state => state.auth.fredAccessToken)

  // // NOTE // this is essentially the pre close-flight process
  // const handleNoShows = async (statusKey, legKey, href) => {
  //   const authConfig = {'Authorization': `Bearer ${token}`}
    
  //   const statusResponse = await axios.get(href, { headers:authConfig })
  //   const output = {
  //     flightLegStatus: {
  //       // NOTE // only one of these be true (active, cancelled, checkInClosed, closed, expired, locked)
  //       active: statusResponse.data.flightLegStatus.closed,
  //       closed: !statusResponse.data.flightLegStatus.closed
  //     },
  //     timestamp: statusResponse.data.timestamp
  //   }
  
  //   // NOTE // go through no-show process if there are passengers and the flight is active
  //   if (paxInfo[rowPax] && paxInfo[rowPax].passengers && !statusResponse.data.flightLegStatus.closed) {
  //     setOpenNoShow(true)
  //   }
  //   else {
  //     dispatch(closeFlight(statusKey, legKey, output))
  //   };
  // }

  const getCheckedInCount = (row) => {
    let passengers = paxInfo[rowPax] && paxInfo[rowPax].passengers ? paxInfo[rowPax].passengers : []
    let checkInCount = 0
    for (let i = 0; i < passengers.length; i++) {
      const pax = passengers[i];
      if (pax.passengerJourneyDetail.travelStatus.checkedIn || pax.passengerJourneyDetail.travelStatus.boarded) {
        checkInCount += 1
      }
    }
    return `${checkInCount}/${passengers.length}`
  }

  useEffect(() => {
    setOpenAccordion(false);
    dispatch(loadPaxInfo(row.key))
  }, [row.key]);

  return (
    <React.Fragment>
      <Modal
        open={openNoShow}
        onClose={() => {setOpenNoShow(false)}}
        aria-labelledby="no-show-modal"
      >
        <NoShowModal paxInfo={paxInfo[rowPax]} row={row} closeModal={setOpenNoShow} />
      </Modal>
      <StyledTableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenAccordion(!openAccordion)}>
            {openAccordion ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <PaxMenu row={row}/>
        </TableCell>
        <TableCell component="th" scope="row" ><h4>{row.flightNum}</h4>{getCheckedInCount(row)}</TableCell>
        <TableCell>{row.departure}</TableCell>
        <TableCell>{row.depTime}</TableCell>
        <TableCell>{row.arrival}</TableCell>
        <TableCell>{row.arrTime}</TableCell>
        {/* NOTE // hiding close-flight for now, check the index for explanation */}
        {/* <TableCell>
          <Checkbox checked={row.closeFlight} onChange={() => handleNoShows(row.statusKey, row.legKey, row.statusHref)} inputProps={{ 'aria-label': 'primary checkbox' }}/>
        </TableCell> */}
      </StyledTableRow>
      <StyledTableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: '1px solid #b9b9b9' }} colSpan={12}>
          <Collapse in={openAccordion} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <PaxList rowKey={row.key} />
            </Box>
          </Collapse>
        </TableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}